import { createAction, props } from '@ngrx/store';
import { Brands } from 'app/models/brand';

export const brandingUpdated = createAction('BRANDING_UPDATED', props<{ branding: Brands }>());
export const themeUpdated = createAction('THEME_UPDATED', props<{ theme: Brands }>());
export const identityUpdated = createAction('IDENTITY_UPDATED', props<{ theme: Brands, branding: Brands }>());

